<template>
  <div class="app-loader" id="loader-form" style="z-index:25;">
    <div style="background:#fff;padding:5px;border-radius:50%;">
      <div class="custom-loader3"></div>
    </div>
  </div>
</template>


<script>

export default {
  props:["loading"],
  components: {
  
  }
}
</script>
